import React from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Button } from "rhombus-react";

import { initiateScoring, PREDICTIVE_SCORE_ENTITY_TYPES } from "reducers/PredictiveScoring";
import { isEligibleForScoring } from "widgets/actions/PredictiveScoringAction";
import { usePredictiveScoringEnabled } from "hooks/usePredictiveScoringEnabled";

export default function BulkScoringVersionsButton({ libraryId }) {
	const dispatch = useDispatch();
	const isPredictiveScoringOn = usePredictiveScoringEnabled();
	const { selectedVersions, creative } = useSelector(state => ({
		selectedVersions: state.selected.versions,
		creative: state.creativeDetails,
	}), shallowEqual);

	if (!isPredictiveScoringOn) {
		return null;
	}

	const { adType, approval } = creative || {};
	if (!isEligibleForScoring(adType, approval)) {
		return null;
	}

	if (!selectedVersions.length) {
		return null;
	}

	function handleClick() {
		return dispatch(initiateScoring(libraryId, PREDICTIVE_SCORE_ENTITY_TYPES.VERSION, selectedVersions, [adType]));
	}

	return (
		<Button
			icon="fas fa-gauge-high"
			style="block"
			theme="blue"
			onClick={handleClick}
		>
			{`Send for Predictive Scoring (${selectedVersions.length})`}
		</Button>
	);
}

BulkScoringVersionsButton.displayName = "BulkScoringVersionsButton";
